import Flatlist from 'flatlist-react';
import { useContext, useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { IoIosCloseCircle } from 'react-icons/io';
import CatalogContext from '../../contexts/catalogContext';
import ClientDataContext from '../../contexts/clientContext';
import CompanyContext from '../../contexts/companyContext';
import { getLastOrderedProducts } from '../../scripts/getLastOrderedProducts';
import { useAppRouter } from '../../hooks/useAppRouter';
import { RenderCatalog } from './components/renderCatalog';
import RenderCategories from './components/renderCategories';
import { RenderLastOrderedProducts } from './components/renderLastOrderedProducts';
import styles from './css/menu.module.css';
import { getCatalog } from './services/getCatalog';
import { Info, Star } from 'lucide-react';


const no_image_vector = require('../../assets/marca-dagua-sofchef.png');



function Menu() {
    const navigate = useAppRouter();
    const { companyData } = useContext(CompanyContext);
    const { clientData } = useContext(ClientDataContext);
    const { catalog, setCatalog } = useContext(CatalogContext);
    const [lastOrderedProducts, setLastOrderedProducts] = useState([]);
    const [category, setCategory] = useState(null);
    const [scrolledScreen, setScrolledScreen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [renderSearchProdList, setRenderSearchProdList] = useState(false);
    const [searchCatalog, setSearchCatalog] = useState([]);



    //  INITIALIZE SCREEN
    useEffect(() => {

        const initScreen = async () => {
            try {

                setLoading(true);

                const resCatalog = await getCatalog({ companyId: companyData.id, restriction: companyData.restriction, clientData: clientData });

                setCategory(resCatalog[0].title);

                setCatalog(resCatalog);

                if (clientData?.client_id) {
                    const resOrderedProducts = await getLastOrderedProducts({ companyId: companyData.id, clientId: clientData?.client_id });
                    setLastOrderedProducts(resOrderedProducts);
                }

            } catch (error) {
                console.error('ERROR - CONSTRUCT SCREEN FUNCTION:', error);

            } finally {
                setLoading(false);
            }
        }

        initScreen();

    }, []);




    // CONTROLA O EVENTO DE SCROLL PARA MODIFICAR O POSICIONAMENTO DA HEADER
    document.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        const spacing = 130;

        if (scrollY > spacing) {
            setScrolledScreen(true);

        } else {
            setScrolledScreen(false);
        }

    });
    
    

    // BUSCA AUTOMÁTICA DE PRODUTOS AO DIGITAR
    useEffect(() => {
        if (search) {
            const list = [];

            catalog.forEach((cat) => {
                const res = cat.products.filter((prod) => prod.name.toLowerCase().includes(search.toLowerCase()));

                if (res.length > 0) {
                    list.push({ ...cat, products: res });
                }
            });

            setSearchCatalog(list);
            setRenderSearchProdList(true);

        } else {
            setSearchCatalog([]);
            setRenderSearchProdList(false);
        }
    }, [search, catalog]);


    // FUNÇÃO DE SELEÇÃO DE CATEGORIA E ROLAGEM PARA A LISTA DA CATEGORIA

    function selectCategory(component) {
        setCategory(component);

        const componente = document.getElementById(component);

        if (componente) {

            componente.scrollIntoView({
                behavior: 'smooth', 
                block: 'start' 
            });

        } else {
            console.error(`Componente não encontrado.`);
        }
    }


    const CategoriesListRender = () => {
        return (
            <div className={styles.categories} id='categories' style={{ backgroundColor: companyData.background_color }}>
                {catalog.length > 0 ? (
                    <div id={styles.scrollComponent} className={styles.scrollComponent}>
                        <div id={styles.componentList} className={styles.componentList}>
                            {catalog.map((item, index) => {
                                return (
                                    <RenderCategories 
                                        key={item.id || index}
                                        item={item} 
                                        companyData={companyData} 
                                        category={category} 
                                        selectCategory={(name) => selectCategory(name)} 
                                    />
                                )
                            })}
                        </div>
                    </div>

                ) : (

                    <p style={{ color: companyData.text_color, textAlign: 'center', alignSelf: 'center', marginLeft: 'auto', marginRight: 'auto' }}>Suas categorias de produtos ficarão aqui!</p>
                )}
            </div>
        )
    }






    // SCREEN ===================================================================>

    return (
        <div className={styles.screen}>

            {/* <======================= HEADER =======================> */}
            <header className={styles.headerMenu}>
                {companyData.show_service || companyData.show_address || companyData.show_comercial_phone || companyData.show_comercial_email ? (
                    <button className={styles.buttonProfile} style={{ backgroundColor: companyData.background_color }} onClick={() => navigate('about')}>
                        <Info size={15} color={companyData.text_color}/>
                        <p className={styles.buttonProfileText} style={{ color: companyData.text_color }}>Perfil da loja</p>
                    </button>
                ) : null}

                <div className={styles.companyIdentityArea}>
                    {companyData.use_image && companyData.image && <img src={companyData.image} className={styles.headerCompanyLogo} alt={'Logo'} />}

                    <div className={styles.companyIdentityTextArea}>
                        {/* COMPANY NAME IN HEADER */}
                        <h1 className={styles.nameCompany}>{companyData.name}</h1>

                        <div style={{flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: 10, marginTop: 10}}>
                            <p className={styles.textStatusAlert} style={{ backgroundColor: companyData.status ? 'green' : 'red' }}>
                                {companyData.status ? 'Aberto' : 'Fechado'}
                            </p>

                            {companyData.orders_blocked ? (
                                <p className={styles.textStatusAlert} style={{ backgroundColor: '#777' }}>
                                    Somente cardápio
                                </p>
                            ) : null}

                            {companyData.rating ? (
                                <a href={companyData.rating} target='_blank'>
                                    <button className={styles.ratingButton} style={{ backgroundColor: companyData.background_color }}>
                                        <span style={{ color: companyData.text_color }}>Avalie-nos</span>
                                    </button>
                                </a>
                            ) : null}

                        </div>
                    </div>
                </div>



                {/* <======================= CATEGORIES =======================> */}
                {!scrolledScreen && (
                    <div className={styles.categoriesArea} id='categories-area'>
                        <CategoriesListRender/>
                    </div>
                )}

            </header>


            <div id={styles.container}>

                {scrolledScreen && (
                    <div className={styles.fixedCategoriesArea}>
                        <CategoriesListRender />
                    </div>
                )}

                {/* BARRA DE BUSCA DE PRODUTOS */}
                <div className={styles.searchProductArea}>
                    <div className={styles.searchBar}>
                        <FaSearch size={18} color={'#888'}/>

                        <input
                            className={styles.searchInput}
                            value={search}
                            placeholder="Buscar produto"
                            onChange={({target: {value}}) => setSearch(value)}
                        />

                        {search && (
                            <button className={styles.searchClearButton} onClick={() => setSearch('')}>
                                <IoIosCloseCircle size={20} color={'#888'}/>
                            </button>
                        )}
                    </div>
                </div>

                {/* AREA DE PRODUTOS PEDIDOS ANTERIORMENTE*/}
                {!renderSearchProdList && lastOrderedProducts.length > 0 && (
                    <section id={styles.combosArea}>
                        <p className={styles.titleCombosArea}>Pedir novamente</p>

                        <div id={styles.scrollComponent} className={styles.scrollComponent} style={{ marginTop: 20, paddingBottom: 5 }}>
                            <div id={styles.componentList} className={styles.componentList}>
                                <Flatlist
                                    list={lastOrderedProducts}
                                    renderItem={(item) => 
                                        <RenderLastOrderedProducts 
                                            item={item} 
                                            companyData={companyData} 
                                        />
                                    }
                                />
                            </div>
                        </div>
                    </section>

                )}



                {/* PRODUCTS AREA */}
                <section id={styles.productsArea}>
                    {(() => {
                        const displayCatalog = renderSearchProdList ? searchCatalog : catalog;

                        if (displayCatalog.length === 0) {
                            return (
                                <p style={{ width: '80%', alignSelf: 'center', marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', marginTop: 100, backgroundColor: '#d3d3d3', padding: 10, borderRadius: 5 }}>
                                    {renderSearchProdList ? 'Nenhum produto encontrado para a busca realizada.' : 'Adicione novos produtos a conta e eles irão aparecer aqui!'}
                                </p>
                            );
                        }

                        return (
                            <div className={styles.productsList}>
                                {displayCatalog.map((item, index) => {
                                    return (
                                        <RenderCatalog
                                            key={item.id || index}
                                            item={item}
                                            companyData={companyData}
                                            clientData={clientData}
                                        />
                                    )
                                })}
                            </div>
                        );
                    })()}
                </section>

            </div>
        </div>
    );
}

export default Menu;
